module.exports = __webpack_public_path__ + "static/media/HCMM317.51e5c336.jpg";